/**
 * @generated SignedSource<<343a34f978d2b811efc3d3a5c2cab0d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentWhatToSeeEditPageQuery$variables = {
  id: string;
};
export type ContentWhatToSeeEditPageQuery$data = {
  readonly whatToSee: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"MediaEditor_mediable" | "SeoTab_seoable" | "WhatToSeeEditExtra_whatToSee" | "WhatToSeeEditMain_whatToSee" | "WhatToSeeSidebar_whatToSee">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeEditMain_data">;
};
export type ContentWhatToSeeEditPageQuery = {
  response: ContentWhatToSeeEditPageQuery$data;
  variables: ContentWhatToSeeEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
],
v7 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentWhatToSeeEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatToSee",
        "kind": "LinkedField",
        "name": "whatToSee",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WhatToSeeSidebar_whatToSee"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WhatToSeeEditMain_whatToSee"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MediaEditor_mediable"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WhatToSeeEditExtra_whatToSee"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoTab_seoable"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "WhatToSeeEditMain_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentWhatToSeeEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WhatToSee",
        "kind": "LinkedField",
        "name": "whatToSee",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Seo",
            "kind": "LinkedField",
            "name": "seo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "poisDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "City",
            "kind": "LinkedField",
            "name": "city",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Poi",
            "kind": "LinkedField",
            "name": "pois",
            "plural": true,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v6/*: any*/),
            "concreteType": "WhatToSeeBlockConnection",
            "kind": "LinkedField",
            "name": "blocks",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WhatToSeeBlockEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WhatToSeeBlock",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": "blocks(first:2147483647)"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "S120X120"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "externalUrl",
                            "storageKey": "externalUrl(size:\"S120X120\")"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w262"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": "src(size:\"w262\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Seo",
                "kind": "LinkedField",
                "name": "seo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaDescription",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Seoable",
            "abstractKey": "__isSeoable"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "CountryConnection",
        "kind": "LinkedField",
        "name": "countries",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "countries(first:2147483647)"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "City",
        "kind": "LinkedField",
        "name": "cities",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Country",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "PoiConnection",
        "kind": "LinkedField",
        "name": "pois",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PoiEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Poi",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "pois(first:2147483647)"
      }
    ]
  },
  "params": {
    "cacheID": "512282410838defa92cb3c3797dd8e11",
    "id": null,
    "metadata": {},
    "name": "ContentWhatToSeeEditPageQuery",
    "operationKind": "query",
    "text": "query ContentWhatToSeeEditPageQuery(\n  $id: ID!\n) {\n  whatToSee(id: $id) {\n    name\n    ...WhatToSeeSidebar_whatToSee\n    ...WhatToSeeEditMain_whatToSee\n    ...MediaEditor_mediable\n    ...WhatToSeeEditExtra_whatToSee\n    ...SeoTab_seoable\n    id\n  }\n  ...WhatToSeeEditMain_data\n}\n\nfragment AddWhatToSeeBlockDialog_whatToSee on WhatToSee {\n  id\n}\n\nfragment CitySelect_data on Query {\n  cities {\n    id\n    name\n    region {\n      id\n      name\n      country {\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment CountrySelect_data on Query {\n  countries(first: 2147483647) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment PoiSelect_data on Query {\n  pois(first: 2147483647) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment RegionSelect_data on Query {\n  regions {\n    id\n    name\n    country {\n      id\n    }\n  }\n}\n\nfragment SeoTab_seoable on Seoable {\n  __isSeoable: __typename\n  id\n  seo {\n    id\n    slug\n    metaTitle\n    metaDescription\n  }\n}\n\nfragment WhatToSeeBlocksFieldSections_blocksConnection on WhatToSeeBlockConnection {\n  edges {\n    node {\n      id\n      name\n      description\n    }\n  }\n}\n\nfragment WhatToSeeBlocksFieldSections_whatToSee on WhatToSee {\n  ...AddWhatToSeeBlockDialog_whatToSee\n}\n\nfragment WhatToSeeBlocksField_blocksConnection on WhatToSeeBlockConnection {\n  ...WhatToSeeBlocksFieldSections_blocksConnection\n}\n\nfragment WhatToSeeBlocksField_whatToSee on WhatToSee {\n  ...WhatToSeeBlocksFieldSections_whatToSee\n}\n\nfragment WhatToSeeEditExtra_whatToSee on WhatToSee {\n  id\n  blocks(first: 2147483647) {\n    edges {\n      node {\n        id\n        name\n        description\n      }\n    }\n    ...WhatToSeeBlocksField_blocksConnection\n  }\n  ...WhatToSeeBlocksField_whatToSee\n}\n\nfragment WhatToSeeEditMainFields_data on Query {\n  ...CountrySelect_data\n  ...RegionSelect_data\n  ...CitySelect_data\n  ...PoiSelect_data\n}\n\nfragment WhatToSeeEditMain_data on Query {\n  ...WhatToSeeEditMainFields_data\n}\n\nfragment WhatToSeeEditMain_whatToSee on WhatToSee {\n  id\n  name\n  description\n  poisDescription\n  country {\n    id\n    name\n  }\n  region {\n    id\n    name\n  }\n  city {\n    id\n    name\n  }\n  pois {\n    id\n    name\n  }\n}\n\nfragment WhatToSeeSidebar_whatToSee on WhatToSee {\n  seo {\n    slug\n    id\n  }\n  ...EntitySidebar_entity\n}\n"
  }
};
})();

(node as any).hash = "8b28ecb5c35d202a8689ae98dae6f396";

export default node;
